import { render, staticRenderFns } from "./PopUpList.vue?vue&type=template&id=8cd0798a&scoped=true&"
import script from "./PopUpList.vue?vue&type=script&lang=js&"
export * from "./PopUpList.vue?vue&type=script&lang=js&"
import style0 from "./PopUpList.vue?vue&type=style&index=0&id=8cd0798a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd0798a",
  null
  
)

export default component.exports